import { render, staticRenderFns } from "./PixPaymentForm.vue?vue&type=template&id=6dc9590e&scoped=true"
import script from "./PixPaymentForm.vue?vue&type=script&lang=js"
export * from "./PixPaymentForm.vue?vue&type=script&lang=js"
import style0 from "./PixPaymentForm.vue?vue&type=style&index=0&id=6dc9590e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc9590e",
  null
  
)

export default component.exports